import { useLoaderData } from "react-router";
import DocumentForm from "../document/DocumentForm";

export default function EditVehicleSetupDocument() {
    const document = useLoaderData();
    return <DocumentForm document={document} />;
}
